export default __webpack_public_path__ + "static/media/x-icon.be9a4958.svg";